import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithDecimal, onlyNumberWithTwoDecimal, onlyNumberWithTwoDecimalNegative } from '../../../components/functions'
import InputMask from 'react-input-mask'
import { useEnergiaRefrigeracaoCamaraContext } from '../../../context/energiaRefrigeracaoCamContext'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { setAtualizacaoGestao } = useTabelaGestao()

    const { energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id } = useEnergiaRefrigeracaoCamaraContext()

    const [aplicacao, setAplicacao] = useState('')
    const [marcaCamara, setMarcaCamara] = useState('')
    const [modeloEvaporadora, setModeloEvaporadora] = useState('')
    const [modeloCondensadora, setModeloCondensadora] = useState('')
    const [anoFabricacaoCamara, setAnoFabricacaoCamara] = useState('')
    const [quantidadeCamara, setQuantidadeCamara] = useState('')
    const [capacidadeTermica, setCapacidadeTermica] = useState('')
    const [potenciaEletricaCamara, setPotenciaEletricaCamara] = useState('')
    const [volumeCamara, setVolumeCamara] = useState('')
    const [temperaturaInterna, setTemperaturaInterna] = useState('')
    const [cop, setCop] = useState('')
    const [fluidoRefrigeranteCamara, setFluidoRefrigeranteCamara] = useState('')
    const [compressao, setCompressao] = useState('')
    const [sistema, setSistema] = useState('')
    const [rotinaManutencao, setRotinaManutencao] = useState('')
    const [entradaOperacaoCamara, setEntradaOperacaoCamara] = useState('')
    const [saidaOperacaoCamara, setSaidaOperacaoCamara] = useState('')
    const [anoFabricacao, setAnoFabricacao] = useState('')

    //const [energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id] = useState()
    const [listaAnos, setListaAnos] = useState()

    const [energiaRefrigeracaoCamaraMarca, setEnergiaRefrigeracaoCamaraMarca] = useState()

    const [resultadoFluidoRefrigerante, setResultadoFluidoRefrigerante] = useState()


    function consultaFluidoRefrigerante() {

        api.get('fluidoRefrigeranteListaTodos').then((result) => {

            //console.log(result.data)

            setResultadoFluidoRefrigerante(result.data.map((rs) =>
            
                <option key={rs.fluidoRefrigerante_id} value={rs.descricao}>{rs.descricao}</option>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }


    function limpaDados() {

        
        setAnoFabricacao('')

        setAplicacao('')
        setMarcaCamara('')
        setModeloEvaporadora('')
        setModeloCondensadora('')
        setAnoFabricacaoCamara('')
        setQuantidadeCamara('')

        setCapacidadeTermica('')
        setPotenciaEletricaCamara('')
        setVolumeCamara('')
        setTemperaturaInterna('')
        setCop('')
        setFluidoRefrigeranteCamara('')
        setCompressao('')
        setSistema('')
        setRotinaManutencao('')
        setEntradaOperacaoCamara('')
        setSaidaOperacaoCamara('')
        
        
    }


    function avisoCop() {

        
        if (potenciaEletricaCamara != '' && capacidadeTermica != '') {

            

            
            var copCalculo = parseFloat(capacidadeTermica.replaceAll(',', '.')) * 3.51685 / parseFloat(potenciaEletricaCamara.replaceAll(',', '.'))
            

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'orange',
                title: 'Aviso',
                content: `Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`,
                buttons: {
                    Ok: function () {
    
                        setCop(copCalculo.toFixed(2).toString().replaceAll('.', ','))
    
                    },
                    
    
                },
    
            });


        }


    }


    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }



    function carregaMarcaCamara() {


        api.get(`energiaRefrigeracaoCamaraMarcaListaTodos`).then((result) => {

            //console.log(result.data)
            setEnergiaRefrigeracaoCamaraMarca(result.data.map((rs) =>

                <option value={rs.descricao} key={rs.energiaRefrigeracaoCamaraMarca_id}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }




    function apagaRefrigeracaoCamara() {



        if (energiaRefrigeracaoCamara_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaRefrigeracaoCamara/${energiaRefrigeracaoCamara_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow2(false)
                            //consultaRefrigeracaoCamara()
                            //window.toastr.sucess('Registro apagado com sucesso')

                            window.$('#modalRefrigeracaoCamara').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }




    }

    function salvaRefrigeracaoCamara() {


        if (aplicacao == '') {

            window.toastr.error('<b>Aplicação</b> não pode ficar em branco!')
            return false

        }

        if (marcaCamara == '') {

            window.toastr.error('<b>Marca</b> não pode ficar em branco!')
            return false

        }

        if (compressao == '') {

            window.toastr.error('<b>Compressão</b> não pode ficar em branco!')
            return false

        }

        if (sistema == '') {

            window.toastr.error('<b>Sistema</b> não pode ficar em branco!')
            return false

        }

        if (rotinaManutencao == '') {

            window.toastr.error('<b>Rotina de Manutenção</b> não pode ficar em branco!')
            return false

        }

        if (quantidadeCamara == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        } else {

            if (quantidadeCamara == '0') {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false

            }
            
        }


        if (cop != '') {

            if (parseFloat(cop.replaceAll(',','.')) == 0) {

                window.toastr.error('<b>COP</b> não pode ser igual a zero!')
                return false
    
            }

        }

    

        if (volumeCamara != '') {


            if (volumeCamara == '0') {

                window.toastr.error('<b>Volume</b> não pode ser igual a zero!')
                return false

            }

        }


        if (capacidadeTermica == '') {

            window.toastr.error('<b>Capacidade Térmica</b> não pode ficar em branco!')
            return false

        } else {

            if (capacidadeTermica == '0') {

                window.toastr.error('<b>Capacidade Térmica</b> não pode ser igual a zero!')
                return false

            }
            
        }


        if (anoFabricacaoCamara == '') {

            window.toastr.error('<b>Ano Fabricação</b> não pode ficar em branco!')
            return false
    
        }

        if (potenciaEletricaCamara == '') {

            window.toastr.error('<b>Potência Elétrica</b> não pode ficar em branco!')
            return false

        } else {

            if (potenciaEletricaCamara == '0') {

                window.toastr.error('<b>Potência Elétrica</b> não pode ser igual a zero!')
                return false

            }
            
        }



        if (entradaOperacaoCamara != '') {


            if (entradaOperacaoCamara.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacaoCamara.split('/')
                var mesEntradaOperacao = x_array[0]


                if (anoFabricacaoCamara != '') {

                    if (parseInt(anoFabricacaoCamara) > parseInt(x_array[1])) {

                        window.toastr.error('<b>Ano de Fabricação</b> não pode ser posterior ao <b>ano de entrada em operação</b>!')
                        return false

                    }

                }
                

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }  else {

                    var dataEntradaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                }


                if (anoFabricacao != '' && x_array[1] != '') {

                    var anoFabricacao_r = parseInt(anoFabricacao)

                    var anoEntradaOperacao = parseInt(x_array[1])

                    if (anoEntradaOperacao < anoFabricacao_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser menor que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacaoCamara != '') {


            if (saidaOperacaoCamara.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacaoCamara.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacao != '' && x_array[1] != '' && x_array[0] != '' && mesEntradaOperacao != '') {
                
                    var anoSaidaOperacao = parseInt(x_array[1])
                    var mesSaidaOperacao = parseInt(x_array[0])

                    if (anoSaidaOperacao < anoEntradaOperacao) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                        return false

                    } else {

                        var dataSaidaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                        if (dataSaidaTemp < dataEntradaTemp) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }

                        /*
                        if (mesSaidaOperacao < parseInt(mesEntradaOperacao)) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }
                        */


                    }


                }


            }
            

        }

        /*


        if (entradaOperacaoCamara != '') {


            if (entradaOperacaoCamara.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacaoCamara.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }


            }
            

        }


        if (saidaOperacaoCamara != '') {


            if (saidaOperacaoCamara.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacaoCamara.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


            }
            
            

        }

        */



        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            aplicacao: aplicacao,
            marcaCamara: marcaCamara,
            modeloEvaporadora: modeloEvaporadora,
            modeloCondensadora: modeloCondensadora,
            anoFabricacaoCamara: anoFabricacaoCamara,
            quantidadeCamara: quantidadeCamara,
            capacidadeTermica: capacidadeTermica,
            potenciaEletricaCamara: potenciaEletricaCamara,
            volumeCamara: volumeCamara,
            temperaturaInterna: temperaturaInterna,
            cop: cop,
            fluidoRefrigeranteCamara: fluidoRefrigeranteCamara,
            compressao: compressao,
            sistema: sistema,
            rotinaManutencao: rotinaManutencao,
            entradaOperacaoCamara: entradaOperacaoCamara,
            saidaOperacaoCamara: saidaOperacaoCamara,


        }

        //console.log(dataPost, '!!')

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaRefrigeracaoCamara_id) {

                        //console.log('put')

                        api.put(`energiaRefrigeracaoCamara/${energiaRefrigeracaoCamara_id}`, dataPost).then((result) => {
    
                            //setShow2(false)
                            //consultaRefrigeracaoCamara()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalRefrigeracaoCamara').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaRefrigeracaoCamara', dataPost).then((result) => {

                           
                            //setShow2(false)
                            //consultaRefrigeracaoCamara()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalRefrigeracaoCamara').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }




    function consultaRefrigeracaoCamaraDet() {

        if (energiaRefrigeracaoCamara_id) {

            api.get(`energiaRefrigeracaoCamaraListaUm/${energiaRefrigeracaoCamara_id}`).then((result) => {

                //console.log(result.data[0])

                var data = result.data[0]

                setAplicacao(data.aplicacao)
                setMarcaCamara(data.marcaCamara)
                setModeloEvaporadora(data.modeloEvaporadora)
                setModeloCondensadora(data.modeloCondensadora)
                setAnoFabricacaoCamara(data.anoFabricacaoCamara == null ? '' : data.anoFabricacaoCamara.toString())
                setQuantidadeCamara(data.quantidadeCamara == null ? '' : data.quantidadeCamara.toString())

                setCapacidadeTermica(data.capacidadeTermica == null ? '' : data.capacidadeTermica.toString())
                setPotenciaEletricaCamara(data.potenciaEletricaCamara == null ? '' : data.potenciaEletricaCamara.toString())
                setVolumeCamara(data.volumeCamara == null ? '' : data.volumeCamara.toString())
                setTemperaturaInterna(data.temperaturaInterna == null ? '' : data.temperaturaInterna.toString())
                setCop(data.cop == null ? '' : data.cop.toString())
                setFluidoRefrigeranteCamara(data.fluidoRefrigeranteCamara)
                setCompressao(data.compressao)
                setSistema(data.sistema)
                setRotinaManutencao(data.rotinaManutencao)
                setEntradaOperacaoCamara(data.entradaOperacaoCamara)
                setSaidaOperacaoCamara(data.saidaOperacaoCamara)

            }).catch((err) => {

                console.log(err.response)

            })

        }

        
    }


    const handleChange = (e) => {
        e.preventDefault();
    }


    useEffect(() => {

        limpaDados()
        carregaAnos()
        carregaMarcaCamara()
        consultaFluidoRefrigerante()
        consultaRefrigeracaoCamaraDet()

    }, [energiaRefrigeracaoCamara_id])


    return (

        <div>

                <div className="modal fade" id="modalRefrigeracaoCamara" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Refrigeração - Câmara Fria </h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">


                            <div className="col-md-12" >
                                        <b>Dados básicos</b>
                                        <br/><br/>
                                </div>
                                    
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Aplicação *</label>
                                        <select class="form-control" value={aplicacao} onChange={event => setAplicacao(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Congelamento">Congelamento</option>
                                            <option value="Exposição">Exposição</option>
                                            <option value="Resfriamento">Resfriamento</option>
                                            
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Marca *</label>
                                        <select class="form-control" value={marcaCamara} onChange={event => setMarcaCamara(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Não informado">Não informado</option>
                                            {energiaRefrigeracaoCamaraMarca}

                                            
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Modelo Evaporadora</label>
                                        <input class="form-control" value={modeloEvaporadora} onChange={event => setModeloEvaporadora(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">Modelo Condensadora</label>
                                        <input class="form-control" value={modeloCondensadora} onChange={event => setModeloCondensadora(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Ano de Fabricação *</label>
                                        <select class="form-control" value={anoFabricacaoCamara} onChange={event => setAnoFabricacaoCamara(event.target.value)}  >

                                            <option value="">[Selecione]</option>
                                            {listaAnos}
                                            <option value="0">Não informado</option>

                                        </select>
                                        
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Quantidade *</label>
                                        <input class="form-control" value={quantidadeCamara} onChange={event => setQuantidadeCamara(event.target.value)}  
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} 
                                        
                                        />
                                            
                                    </div>
                                </div>



                                <div className="col-md-12" >
                                    <br/><br/><br/>
                                    <b>Dados técnicos</b>
                                    <br/><br/>
                                </div>

                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Capacidade Térmica [TR] *</label>
                                        <input class="form-control" value={capacidadeTermica} onChange={event => setCapacidadeTermica(event.target.value)} onBlur={() => avisoCop()}
                                        onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        />
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Potência Elétrica [kW] *</label>
                                        <input class="form-control" value={potenciaEletricaCamara} onChange={event => setPotenciaEletricaCamara(event.target.value)}  onBlur={() => avisoCop()}
                                        onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        />
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Volume [m<sup>3</sup>]</label>
                                        <input class="form-control"  value={volumeCamara}  onChange={event => setVolumeCamara(event.target.value)} 
                                        onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        />
                                            
                                    </div>
                                </div>


                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Temperatura Interna [<sup>o</sup>C]</label>
                                        <input class="form-control" value={temperaturaInterna} onChange={event => setTemperaturaInterna(event.target.value)} 
                                        onKeyPress={(e)=>onlyNumberWithTwoDecimalNegative(e)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        
                                        />

                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">COP [W/W]</label>
                                        <input class="form-control" value={cop} onChange={event => setCop(event.target.value)} 
                                        onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        />
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Fluído Refrigerante</label>
                                        <select class="form-control" value={fluidoRefrigeranteCamara} onChange={event => setFluidoRefrigeranteCamara(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {resultadoFluidoRefrigerante}
                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Compressão *</label>
                                        <select class="form-control" value={compressao} onChange={event => setCompressao(event.target.value)} >
                                            <option value="">[Selecione]</option>
                                            <option value="Água">Água</option>
                                            <option value="Ar">Ar</option>
                                            
                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-12" >
                                    <br/><br/><br/>
                                    <b>Dados Operacionais</b>
                                    <br/><br/>
                                </div>

                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        <br/>
                                        
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Sistema *
                                                <div class="tooltip">
                                                Câmaras frias pertencentes ao mesmo sistema devem receber a mesma numeração. 

                                                </div>
                                            </span>

                                        </label>
                                        
                                        <select class="form-control" value={sistema} onChange={event => setSistema(event.target.value)} >
                                            <option value="">[Selecione]</option>
                                            <option value="#01">#01</option>
                                            <option value="#02">#02</option>
                                            <option value="#03">#03</option>
                                            <option value="#04">#04</option>
                                            <option value="#05">#05</option>
                                            <option value="#06">#06</option>
                                            <option value="#07">#07</option>
                                            <option value="#08">#08</option>
                                            <option value="#09">#09</option>
                                            <option value="#10">#10</option>
                                            <option value="#11">#11</option>
                                            <option value="#12">#12</option>
                                            <option value="#13">#13</option>
                                            <option value="#14">#14</option>
                                            <option value="#15">#15</option>
                                            <option value="#16">#16</option>
                                            <option value="#17">#17</option>
                                            <option value="#18">#18</option>
                                            <option value="#19">#19</option>
                                            <option value="#20">#20</option>
                                            
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Rotina de manutenção *</label>
                                        <select class="form-control" value={rotinaManutencao} onChange={event => setRotinaManutencao(event.target.value)} >
                                            <option value="">[Selecione]</option>
                                            <option value="Periódica Semanal">Periódica Semanal</option>
                                            <option value="Periódica Mensal">Periódica Mensal</option>
                                            <option value="Periódica Anual">Periódica Anual</option>
                                            <option value="Corretiva (mediante falha)">Corretiva (mediante falha)</option>
                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Entrada em operação (Mês/Ano)
                                                <div class="tooltip">
                                                insira a data (mês e ano) quando o equipamento entrou em operação na unidade.

                                                </div>
                                            </span>

                                        </label>
                                        
                                        <InputMask mask="99/9999" placeholder="MM/AAAA" class="form-control" value={entradaOperacaoCamara} onChange={event => setEntradaOperacaoCamara(event.target.value)} />
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Saída de operação (Mês/Ano)
                                                <div class="tooltip">
                                                insira a data (mês e ano) quando o equipamento saiu de operação na unidade.


                                                </div>
                                            </span>

                                        </label>
                                        
                                        <InputMask mask="99/9999" placeholder="MM/AAAA" class="form-control" value={saidaOperacaoCamara} onChange={event => setSaidaOperacaoCamara(event.target.value)} />
                                            
                                    </div>
                                </div>

                                
                                
                                




                            </div>



                            </div>
                            <div className="modal-footer">


                                <button type="button" className="btn btn-danger" onClick={() => apagaRefrigeracaoCamara()} style={{ display: energiaRefrigeracaoCamara_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaRefrigeracaoCamara()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal